import { Component, Input, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { updateUID } from '../../store/actions/config.actions';
import { loadData } from '../../store/actions/data.actions';
import { CONFIG } from '../../store/reducer/config.reducer';
import { DATA } from '../../store/reducer/data.reducer';

@Component({
    selector: 'app-part-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.scss'],
    standalone: false
})
export class ViewComponent implements OnInit {
  config$ = this.store.select((state) => state.config);
  searchVal: string = '';

  @Input() uid: string;
  @Input() pageId: string;

  constructor(private store: Store<{ data: DATA; config: CONFIG }>) {}

  ngOnInit() {
    this.store.dispatch(updateUID(this.uid));

    // Load XML data
    this.store.dispatch(loadData(this.uid));
  }
}
